module.exports = __webpack_public_path__ + "media/images/bg_verifications-4cdd34a0c3c9cf54e9112a66b5065a39.svg";